export default __webpack_public_path__ + "static/media/Page03-IMG2.ccfbc26a.png";